import React, { useEffect, useState } from "react";
import { Badge, Form, Modal, Table } from "react-bootstrap";
import { BsSearch } from "react-icons/bs";
import { inboxServices } from "../../APIServices/SitePilotManagement/inboxServices";
import { formatDuration, limitText } from "../../APIHelpers/utils";
import { useLiveDuration } from "../../Hooks/DurationHook";
import Moment from "react-moment";

const ViewSessionList = ({
  show,
  hide,
  title,
  inboxId,
  sessionId,
  setSessionId,
  openChat,
  handleChatClick,
}) => {
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [allSessions, setAllSessions] = useState([]);

  const getSingleInboxSessionList = async (inboxId) => {
    setLoader(true);
    const data = await inboxServices.getSingleInboxSessionList(inboxId);
    setSessions(data?.data || []);
    setAllSessions(data?.data || []);
    setLoader(false);
  };

  const getSingleInbox = async (inboxId, newSessionId) => {
    const data = await inboxServices.getSingleInbox(inboxId, newSessionId);
    handleChatClick(data?.data || "");
  };

  const handleSearch = (value) => {
    setSearch(value);
    const query = value.trim().toLowerCase();
    if (!query) {
      setSessions(allSessions);
      return;
    }
    const filtered = allSessions.filter(
      (item) =>
        item.lastMessage?.toLowerCase().includes(query) ||
        item.chatStatus?.toLowerCase().includes(query)
    );

    setSessions(filtered);
  };

  useEffect(() => {
    if (inboxId && show) {
      getSingleInboxSessionList(inboxId);
    }
  }, [show]);

  const SessionRow = ({ item, index }) => {
    const liveDuration = useLiveDuration(
      item.startedDT,
      !(item.chatStatus === "closed" || item.sessionStatus === "closed")
    );

    return (
      <tr
        key={index}
        role="button"
        onClick={() => {
          if (sessionId !== item.sessionId) {
            setSessionId(item.sessionId);
            if (openChat) {
              getSingleInbox(item.inboxId, item.sessionId);
            }
            hide();
          }
        }}
        className={`align-middle CP ${sessionId === item.sessionId ? "table-active" : ""}`}
      >
        <td style={{ fontSize: 12 }}>
          {limitText(item.lastMessage || "_", 35)}
        </td>
        <td className="text-center">
          <Badge
            pill
            bg="transparent"
            className={`tag-pill text-capitalize text-${item?.chatStatus === "browsing" ? "dark" : item?.chatStatus === "open" ? "danger" : "success"}`}
            style={{
              width: "70px",
              border: `1px solid var(--${item?.chatStatus === "browsing" ? "warning" : item?.chatStatus === "open" ? "danger" : "success"})`,
            }}
          >
            {item?.chatStatus}
          </Badge>
        </td>
        <td className="text-center">
          <Badge
            pill
            bg="transparent"
            className={`tag-pill text-capitalize text-${item?.answered ? "success" : "danger"}`}
            style={{
              width: "70px",
              border: `1px solid var(--${item?.answered ? "success" : "danger"})`,
            }}
          >
            {item.answered ? "Answered" : "Missed"}
          </Badge>
        </td>
        <td className="text-center">
          <Badge
            pill
            bg="transparent"
            className={`tag-pill text-capitalize text-${item?.sessionStatus === "open" ? "danger" : "success"}`}
            style={{
              width: "70px",
              border: `1px solid var(--${item?.sessionStatus === "browsing" ? "warning" : item?.sessionStatus === "open" ? "danger" : "success"})`,
            }}
          >
            {item?.sessionStatus}
          </Badge>
        </td>
        <td className="text-center">
          <span className="text-secondary me-1">
            {item.chatStatus === "closed"
              ? formatDuration(item.startedDT, item.endedDT)
              : liveDuration}
          </span>
        </td>
      </tr>
    );
  };

  return (
    <Modal show={show} onHide={hide} size="lg">
      <Modal.Header closeButton className="p-3">
        <Modal.Title style={{ fontSize: 15 }}>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-0">
        {/* Search */}
        <div className="position-relative p-3">
          <BsSearch className="search-icon" style={{ left: 25 }} />
          <Form.Control
            size="sm"
            value={search}
            onChange={(e) => handleSearch(e.target.value)}
            autoFocus
            placeholder="Search..."
            className="search-input"
          />
        </div>

        {/* Table */}
        <div
          className="px-3 pb-3 overflow-auto"
          style={{ maxHeight: "calc(100vh - 180px)" }}
        >
          <Table hover responsive size="sm" className="mb-0">
            <thead className="table-light">
              <tr style={{ fontSize: 12 }}>
                <th>Last Message</th>
                <th className="text-center" style={{ width: 80 }}>Chat</th>
                <th className="text-center" style={{ width: 80 }}>Answered</th>
                <th className="text-center" style={{ width: 80 }}>Session</th>
                <th className="text-center" style={{ width: 80 }}>Duration</th>
              </tr>
            </thead>
            <tbody>
              {sessions?.length ? (
                sessions.map((item, index) => (
                  <SessionRow key={index} item={item} index={index} />
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center text-muted py-3">
                    No sessions found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ViewSessionList;
